import type { AppRole } from '@/contexts/AuthContext';

export function getHomeRouteForRole(role: AppRole | null | undefined): string {
  if (role === 'instituicao_financeira') {
    return '/financiamento/painel';
  }

  return '/empreendimentos';
}
